module.exports = __webpack_public_path__ + "vg.svg?4236b3592713a56c25d146f790e2a4f4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/vg.svg
// module id = 1687
// module chunks = 0